<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="$l('dialog_title_adjust_quantity') || '调整出货数量'"
      :visible="visible"
      direction="rtl"
      :size="1100"
      :wrapperClosable="false"
      @close="() => $refs.main.cancel()"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :disabled="disabled"
          @close="close"
          @showButton="showButton"
          :hxShipmentJdCode="hxShipmentJdCode"
        />
      </div>
      <div class="drawer-footer">
        <el-button
          v-if="!disabled && showSaveButton"
          type="primary"
          size="small"
          @click="$refs.main.save()"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    hxShipmentJdCode: { type: String, default: '' },
  },
  data() {
    return {
      showSaveButton: false,
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    showButton(val) {
      this.showSaveButton = !!val
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 30px 10px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
